// ---------------------------------------------------------------------------
// ToolResponsePanel — re-exported from the shared @promptlayer/ui package.
//
// All rendering logic lives in @promptlayer/ui/src/chat/ToolResponsePanel.tsx.
// To change how the tool response UI looks, edit that file and the change
// will apply to both Vibes and promptlayer_app/frontend.
// ---------------------------------------------------------------------------

import type { ToolResponseMessage } from "@promptlayer/ui";
import { ToolResponsePanel as SharedToolResponsePanel } from "@promptlayer/ui";

import { PendingToolCall } from "@/components/Playground/Drawer/Chat/hooks/useChatState";
import { MessageType } from "@/components/Playground/types";
import { Content } from "@/types";

interface ToolResponsePanelProps {
  pendingToolCalls: PendingToolCall[];
  onSubmit: (
    messages: {
      role: MessageType;
      content: Content[];
      tool_call_id: string;
      name: string;
    }[],
  ) => void;
  isLoading?: boolean;
}

/**
 * Thin wrapper that adapts the frontend's callback signature to the shared
 * component. The shared ToolResponsePanel emits `ToolResponseMessage[]`
 * (with `role: "tool"`), while the frontend expects `MessageType` for the role.
 */
export const ToolResponsePanel = ({
  pendingToolCalls,
  onSubmit,
  isLoading,
}: ToolResponsePanelProps) => {
  const handleSubmit = (messages: ToolResponseMessage[]) => {
    // The shared component emits role: "tool" which is compatible with MessageType
    onSubmit(messages as unknown as Parameters<typeof onSubmit>[0]);
  };

  return (
    <SharedToolResponsePanel
      pendingToolCalls={pendingToolCalls}
      onSubmit={handleSubmit}
      isLoading={isLoading}
    />
  );
};
